<div *ngIf="logo">
  <img class="logo" [src]="logo" />
</div>

<div *ngIf="!logo" class="upload-logo" [routerLink]="'/settings/profile'">
  {{ 'Portal.InspectionCompanies.UploadLogo.Label' | translate }}</div>